import { ServiceClient } from 'src/utils'
import { ExportDocumentsResponse } from 'src/components/exportdocuments/export_documents_scope'
import { UserRow } from '../admin/user-manager/um_scopes'
import { AggMesAnoHistoryRow, ExportHistoryRow, HistoryQueryFilter, HistoryResponse } from './up_scopes'

const serviceClient = ServiceClient.singleton()

export class UserProfileService {
    static #INSTANCE = new UserProfileService()
    static readonly singleton = () => UserProfileService.#INSTANCE

    async fetchProfile(): Promise<UserRow> {
        const data = await serviceClient.authGet<UserRow>(`/api/profile`)
        return data
    }

    async fetchHistory(query: HistoryQueryFilter): Promise<HistoryResponse<ExportHistoryRow>> {
        const queryParams = new URLSearchParams()
        query.startMonth && queryParams.append('startMonth', query.startMonth?.toString() || '')
        query.endMonth && queryParams.append('endMonth', query.endMonth?.toString() || '')
        query.page && queryParams.append('page', query.page.toString())
        query.limit && queryParams.append('limit', query.limit.toString())

        const data = await serviceClient.authGet<HistoryResponse<ExportHistoryRow>>(
            `/api/profile/monthly-export-history?${queryParams.toString()}`
        )
        return data
    }

    async fetchExportDocuments(
        exportId: number,
        query: { page: number; limit: number }
    ): Promise<ExportDocumentsResponse> {
        const queryParams = new URLSearchParams()
        queryParams.append('page', (query.page || 0).toString())
        queryParams.append('limit', (query.limit || 10).toString())

        const data = await serviceClient.authGet<ExportDocumentsResponse>(
            `/api/profile/export/${exportId}/documents?${queryParams.toString()}`
        )
        return data
    }

    async fetchChartHistory(
        query: HistoryQueryFilter,
        agg_types?: string[]
    ): Promise<HistoryResponse<AggMesAnoHistoryRow>> {
        const queryParams = new URLSearchParams()
        query.startMonth && queryParams.append('startMonth', query.startMonth?.toString() || '')
        query.endMonth && queryParams.append('endMonth', query.endMonth?.toString() || '')
        query.page && queryParams.append('page', query.page.toString())
        query.limit && queryParams.append('limit', query.limit.toString())
        agg_types && agg_types.length > 0 && queryParams.append('types', agg_types.join(','))

        const data = await serviceClient.authGet<HistoryResponse<AggMesAnoHistoryRow>>(
            `/api/profile/aggregate-export-history?${queryParams.toString()}`
        )
        return data
    }
}

export default UserProfileService.singleton()
